module.exports = __webpack_public_path__ + "static/media/uiux.6e117c67.webp";